<template>
  <main class="main-container">
    <div class="k-onboarding__quest-wrapper">
      <div class="k-onboarding__quest">
        <div class="k-onboarding__title">Вход</div>
        <div class="k-registration__input-wrapper">
          <input
            :class="['k-registration__input k-registration__email-input jq-onboarding-input', {'has-error': !!errors.email}]"
            type="email"
            placeholder="E-mail"
            title="E-mail"
            id="registration_email"
            v-model="form.email"
            @keydown="clearError('email')"
            @change="validateEmail"
            required
            v-focus
          />
        </div>
        <div v-if="errors.email" class="error-message">{{errors.email}}</div>

        <div class="k-registration__input-wrapper">
          <input
            :class="['k-registration__input k-registration__email-input jq-onboarding-input', {'has-error': !!errors.password}]"
            type="password"
            placeholder="Пароль"
            title="Пароль"
            id="registration_password"
            v-model="form.password"
            @keydown="clearError('password')"
            required
          />
        </div>
        <div v-if="errors.password" class="error-message">{{errors.password}}</div>

        <a
          href="#"
          :class="['k-onboarding__quest-next', {'active': canLogin}]"
          @click="login"
        >
          <span v-if="!isLoading">Войти</span>
          <the-spinner v-else low button/>
        </a>
        <router-link to="/registration" class="k-orange-link p-2">У меня нет аккаунта</router-link>
      </div>
    </div>
  </main>
</template>

<script>
import apiUser from '../api/UserApi';

import { mapActions } from 'vuex';
import TheSpinner from '../components/TheSpinner.vue';

export default {
  name: "AuthLogin",
  components: {
    TheSpinner
  },
  data: function() {
    return {
      form: {
        email: '',
        password: '',
      },
      errors: {
        email: null,
        password: null,
      },
      isLoading: false,
    };
  },
  computed: {
    canLogin: function() {
      return Object.values(this.form).every(el => !!el) && !Object.values(this.errors).some(el => !!el)
    }
  },
  methods: {
    ...mapActions([
      'loadUser'
    ]),
    validateEmail() {
      if (!this.form.email) {
        this.errors.email = "Поле E-mail обязательно для заполнения.";
      } else if (!/(.+)@(.+){2,}\.(.+){2,}/.test(this.form.email)) {
        this.errors.email = "Неверный формат поля E-mail.";
      }
    },
    clearError(field) {
      this.errors[field] = null;
    },
    login() {
      this.isLoading = true;
      apiUser.login(this.form)
        .then(async ({ data }) => {
          if (!data.success) {
            for (let key in data.errors) {
              if (typeof this.errors[key] !== "undefined") {
                this.errors[key] = data.errors[key];
              }
            }
            this.isLoading = false;
          } else {
            await this.loadUser()
            this.$router.push({ name: 'Index' })
            this.isLoading = false;
          }
        })
        .catch(err => {
          console.error("Error during auth: ", err)
          this.isLoading = true;
        });
    }
  }
};
</script>

<style scoped>
</style>
